import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CTASection from "./components/CTASection";
import CategoryGrid from "./components/CategoryGrid";
import ContentSection from "./components/ContentSection";
import AboutSection from "./components/AboutSection";
import TrustSection from "./components/TrustSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main>
      <Navbar />
      <Hero />
      <CTASection />
      <CategoryGrid />
      <ContentSection />
      <AboutSection />
      <TrustSection />
      <Footer />
    </main>
  );
}